import { render } from "./AdminUpload.vue?vue&type=template&id=0ec70212"
import script from "./AdminUpload.vue?vue&type=script&lang=js"
export * from "./AdminUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__